import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useRecordWebcam } from 'react-record-webcam'
import VideocamIcon from "@material-ui/icons/Videocam";
import { colors } from "../layout/constants";

let image;
const VideoStarted = ({ getImage, askImage, microphoneOK, sendPictureWithOutMicrophone }) => {
    const [loading, setLoading] = useState(true);
    const recordWebcam = useRecordWebcam({ 
        frameRate: 60,
        mimeType: 'video/webm;codecs=vp9' 
    });
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const startButtonRef = useRef(null);

    //cliclo
    //open camara
    //start recording
    //stop recording

    useEffect(() => {
        recordWebcam.open();
    }, []);

    useEffect(() => {
        if (microphoneOK) recordWebcam.stop();
    }, [microphoneOK]);

    useEffect(() => {
        if (sendPictureWithOutMicrophone) recordWebcam.stop();
    }, [sendPictureWithOutMicrophone]);

    useEffect(() => {
        console.log(recordWebcam?.status)
        if (recordWebcam?.status === 'OPEN') {
            recordWebcam.start();

            // take image
            if (canvasRef.current) {
                const ctx = canvasRef.current.getContext("2d");
                ctx.drawImage(recordWebcam.webcamRef.current, 115, 80, 115, 80);
                image = canvasRef.current.toDataURL("image/jpg");
            }
        }
        if (recordWebcam?.status === 'RECORDING') {
            
        }
        if (recordWebcam?.status === 'PREVIEW') {
            sendFile();
        }
    }, [recordWebcam?.status]);

    const sendFile = async () => {
        const blob = await recordWebcam.getRecording();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = (event) => {
            const base64data = reader.result.replace(";codecs=vp9,opus", "");
            getImage(base64data, image);
        };
    };


    return (
        <div>
            <VideoStyled>
                <video ref={recordWebcam.webcamRef} autoPlay muted
                    style={{
                        borderRadius: 4,
                        backgroundColor: 'rgb(0, 0, 0, 0.2)',
                        display: 'flex',
                        justifyContent: 'center',
                        height: 80,
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: 115,
                        zIndex: 5
                    }}
                />
                <canvas ref={canvasRef} className="canvas"></canvas>
                <video ref={recordWebcam.previewRef} autoPlay muted loop
                    style={{
                        borderRadius: 4,
                        backgroundColor: 'rgb(0, 0, 0, 0.2)',
                        display: 'flex',
                        justifyContent: 'center',
                        height: 80,
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: 115,
                        zIndex: 5,
                        opacity: 0
                    }}
                />
            </VideoStyled>
        </div>
    )
}

const VideoStyled = styled.article`
	overflow: hidden;
	/* border: 1px solid gray; */
	border-radius: 4px;

	.video-loading {
		align-items: center;
		background-color: rgb(0, 0, 0, 0.2);
		border-radius: 4px;
		color: ${colors.primary};
		cursor: pointer;
		display: flex;
		height: 150px;
		justify-content: center;
		position: fixed;
		bottom: 10px;
		right: 10px;
		width: 200px;
		z-index: 5;

		:hover {
			color: ${colors.primaryLight};
		}
	}

	.MuiSvgIcon-root {
		font-size: 2em;
	}

	.video-player {
		border-radius: 4px;
		background-color: rgb(0, 0, 0, 0.2);
		display: flex;
		justify-content: center;
		height: 80px;
		position: fixed;
		top: 0px;
		right: 0px;
		width: 115px;
		z-index: 5;
	}

	.canvas {
		display: none;
	}

	@media (max-width: 460px) {
		top: 1em;
		right: 0;
		position: absolute;
		height: 115px;
		width: 150px;

		.video-player {
			width: 150px;
		}

		height: 115px;
		width: 150px;
	}
`;

export default VideoStarted;